import { apiSlice } from './apiSlice';
import { NotificationActions } from './notificationSlice';

export const campaignMonitoringSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getOrganizationCampaigns: builder.query({
            query: (organizationId) => `/organizations/${organizationId}/campaigns`,
            providesTags: (result, error, arg) => [{ type: 'Campaign', id: arg }],
            async onQueryStarted({}, { dispatch, queryFulfilled }) {
                try {
                    await queryFulfilled;
                } catch {
                    dispatch(NotificationActions.addErrorNotification({ 
                        message: 'Could not load campaigns at this time. Please try again later.' 
                    }));
                }  
            },
        }),
        refreshCampaignData: builder.mutation({
            query: (organizationId) => ({
                url: `/organizations/${organizationId}/campaigns/refresh`,
                method: 'POST',
            }),
            async onQueryStarted(organizationId, { dispatch, queryFulfilled }) {
                try {
                    const { data: refreshedCampaigns } = await queryFulfilled;
                    
                    // Update the cache with the new data instead of invalidating
                    dispatch(
                        apiSlice.util.updateQueryData(
                            'getOrganizationCampaigns',
                            organizationId,
                            (draft) => {
                                // Replace the entire campaigns array with the refreshed data
                                return refreshedCampaigns;
                            }
                        )
                    );
                    
                    dispatch(NotificationActions.addSuccessNotification({ 
                        message: 'Campaign data refreshed successfully.' 
                    }));
                } catch {
                    dispatch(NotificationActions.addErrorNotification({ 
                        message: 'Could not refresh campaign data. Please try again later.' 
                    }));
                }  
            },
        }),
        getOrganizationPacksForMonitoring: builder.query({
            query: (organizationId) => `/organizations/${organizationId}/packs`,
            providesTags: ['PackList'],
            async onQueryStarted({}, { dispatch, queryFulfilled }) {
                try {
                    await queryFulfilled;
                } catch {
                    dispatch(NotificationActions.addErrorNotification({ 
                        message: 'Could not load packs at this time. Please try again later.' 
                    }));
                }  
            },
        }),
        getPackMonitoringData: builder.query({
            query: (packId) => `/packs/${packId}/summary`,
            providesTags: (result, error, arg) => [{ type: 'Pack', id: arg }],
            async onQueryStarted({}, { dispatch, queryFulfilled }) {
                try {
                    await queryFulfilled;
                } catch {
                    dispatch(NotificationActions.addErrorNotification({ 
                        message: 'Could not load pack at this time. Please try again later.' 
                    }));
                }  
            },
        }),
    }),
});

export const {
    useGetOrganizationCampaignsQuery,
    useRefreshCampaignDataMutation,
    useGetOrganizationPacksForMonitoringQuery,
    useGetPackMonitoringDataQuery,
} = campaignMonitoringSlice;
